function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSezione05Popup04Ico05(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 162.88 119.13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M17.63,88.79c0,4.56-3.69,8.25-8.24,8.25s-8.24-3.69-8.24-8.25,3.69-8.24,8.24-8.24,8.24,3.69,8.24,8.24ZM136.27,101.83c0,4.55-3.69,8.24-8.24,8.24s-8.24-3.69-8.24-8.24,3.69-8.24,8.24-8.24,8.24,3.69,8.24,8.24ZM14.51,17.46c0,3.69-2.99,6.68-6.68,6.68s-6.68-2.99-6.68-6.68,2.99-6.68,6.68-6.68,6.68,2.99,6.68,6.68ZM42.24,48.99c0,3.69-2.99,6.68-6.68,6.68s-6.68-2.99-6.68-6.68,2.99-6.69,6.68-6.69,6.68,3,6.68,6.69ZM87.77,8.45c0,4.04-3.27,7.3-7.3,7.3s-7.3-3.27-7.3-7.3,3.27-7.3,7.3-7.3,7.3,3.27,7.3,7.3Z",
    style: {
      fill: "none",
      stroke: "#e7b835",
      strokeLinejoin: "round",
      strokeWidth: "2.3px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.23,93.4l15.66,11.64M81.08,15.75l1.62,19.3M42.49,44.52l34.54-31.18M13.92,81.9l17.97-27.33M48.62,80.55l-31.15,6.6M112.3,90.61l9.03,6.42M131.2,78.5l-2.06,15.16M119.79,27.57l-33.24-17.08M14.45,16.64l58.77-7.28M12.23,22.47l18.93,21.52",
    style: {
      fill: "none",
      stroke: "#e7b835",
      strokeLinejoin: "round",
      strokeWidth: "2.3px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.79,112.86l-4.09-21.58c7.17-2.39,22.63-9.84,29.93-21.07M162.69,46.39l-13.63,2.28M130.52,44.62l6.54-.64c1.92-.33,3.88,1.84,4.38,4.83.51,2.98-.65,5.67-2.58,5.99l-6.32,1.51M145.97,39.26l11.18-7.52M160.89,62.28l-12.56-3.76M144.78,32.19c-2.91-3.31-6.4-5.08-9.85-4.52-7.14,1.15-11.39,11.71-9.49,23.61,1.9,11.9,9.22,20.62,16.37,19.48,2.92-.46,5.36-2.51,7.08-5.57",
    style: {
      fill: "none",
      stroke: "#e7b835",
      strokeLinejoin: "round",
      strokeWidth: "2.3px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.23,67.56s-13.38-1.6-24.16-.7c-3.53.29-7.05-2.51-8.25-4.18-2.18-.43-5.57-3.31-5.99-6.76-.63-5.16,2.41-8.21,4.8-9.33,1.78-3.57,4.96-5.55,7.72-6.17,12.07-2.76,18.71-7.65,22.48-9.89",
    style: {
      fill: "none",
      stroke: "#e7b835",
      strokeLinejoin: "round",
      strokeWidth: "2.3px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.71,68.81c-3.75,2.38-10.35,4.31-16.34,5.93l-7.82,11.45-12.69-8.06c-6.05.92-10.64,5.19-13.23,9.62-3.15,5.4-7.85,15.17-8.76,22.27-.48,3.72.8,7.94,5.18,7.94h27.16c3.13,0,5.66-2.51,5.66-6.35,0-4.03-2.53-6.76-5.66-6.76h-17.27l3.9-6.9",
    style: {
      fill: "none",
      stroke: "#e7b835",
      strokeLinejoin: "round",
      strokeWidth: "2.3px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.74,58.77c2.37,9.25,11.77,14.83,21.02,12.46,9.25-2.36,14.83-11.77,12.47-21.02-2.36-9.25-11.77-14.82-21.02-12.46-9.25,2.36-14.83,11.77-12.46,21.02Z",
    style: {
      fill: "none",
      stroke: "#e7b835",
      strokeLinejoin: "round",
      strokeWidth: "2.3px"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSezione05Popup04Ico05);
export default __webpack_public_path__ + "static/media/sezione-05-popup-04-ico-05.85c1c43e0218933c1da9c0025c181f1c.svg";
export { ForwardRef as ReactComponent };